/* global ghwp */
/**
 * Open links to (larger) images in modal overlay/lightbox
 */

import GLightbox from 'glightbox/src/js/glightbox';
import { $$ } from './utils/querySelector';

export const plyrOptions = {
    js: ghwp.plyrScriptUrl,
    css: ghwp.plyrStyleUrl,
    config: {
        iconUrl: ghwp.plyrIconUrl,
    },
};

export const modals = (
    modalSelector = '.ghwp-modal',
    buttonSelector = 'a[href^="#"]'
) => {
    const modals = $$()(modalSelector);
    if (modals.length > 0) {
        for (let modal of modals) {
            let skinSuffix = 'clean';
            modal.classList.forEach(cls => {
                const match = cls.match(/^is-style-(.+)$/);
                if (match) {
                    skinSuffix = match[1];
                }
            });
            const lb = GLightbox({
                selector: null,
                onOpen: () => {
                    modal.classList.remove('ghwp-hide');
                },
                skin: skinSuffix,
                plyr: plyrOptions,
                ...(skinSuffix === 'search-overlay' && {
                    openEffect: 'none',
                    closeEffect: 'none',
                }),
            });
            lb.setElements([
                {
                    content: modal,
                    type: 'inline',
                },
            ]);
            const buttons = $$()(buttonSelector);

            for (let button of buttons) {
                const hash = button.href.match(/#([^?&\s]*)/);
                if (hash.length >= 2 && hash[1] === modal.id) {
                    button.addEventListener('click', (event) => {
                        event.preventDefault();
                        lb.open();
                    });
                }
            }
        }
    }
};
